import React from 'react'

const Car = (props) => { // on créeer un composant de type fonction, car on n'a pas besoin d'utiliser un state ( qui est un objet )
// console.log(props);
  return(
      <div className="mx-auto bg-danger container w-25 p-2 m-2 ">
            <p>Marque : {props.children} </p>
          <p className={props.abruti}>Couleur:  {props.color} {props.trucmuch}</p>
      </div>
  )
}

export default Car